const getFirstName = (user) => user ? user.firstname : "";
const getLastName = (user) => user ? user.lastname : "";
const getEmailAddress = (user) => user ? user.email : "";
const getFullName = (user) => user ? `${user.firstname} ${user.lastname}` : "";
const userGetters = {
  getFirstName,
  getLastName,
  getEmailAddress,
  getFullName
};
var userGetters_default = userGetters;
export {
  userGetters_default as default,
  getEmailAddress,
  getFirstName,
  getFullName,
  getLastName
};
